import HardwareSerializer from 'eflex/serializers/hardware';

export default class AudioSerializer extends HardwareSerializer {}
